import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { Hairline } from 'secondstep-components'

export const DividerHairline = styled(Hairline)`
  margin: ${themeGet('spacing.turquoise20_1_25rem')} 0;
`
